export const headText = {
  pageTitle: 'User Management',
};

export const filterText = {
  searchPlaceholder: 'Cari...',
  filterRolePlaceholder: 'Pilih Role',
  filterBrandPlaceholder: 'Pilih Brand',
  filterPlatformPlaceholder: 'Pilih Platform',
  filterStatusPlaceholder: 'Pilih Status',
  createButton: 'Create user',
  clearFilterButton: 'Clear Filters',
};

export const tableText = {
  name: 'Nama',
  email: 'Email',
  brands: 'Brand',
  platform: 'Platform',
  roleName: 'Role',
  handphone: 'No. WA',
  domicile: 'Domisili',
  status: 'Status',
  action: 'Action',
};

export const deleteActionText = {
  titleText: 'Apakah kamu yakin ingin menghapus user ini?',
  contentText: 'Tindakan ini tidak bisa dibatalkan, dan semua detail terkait akan hilang.',
  submitButtonText: 'Hapus sekarang',
  cancelButtonText: 'Batal',

  loadingTitle: 'Harap tunggu',
  loadingDescription: 'Sedang menghapus role...',
  successDescrption: 'Role berhasil dihapus',
  errorTitle: 'Gagal menghapus role..',
  errorDescription: 'Terjadi kesalahan saat menghapus role. Silakan coba lagi atau periksa koneksi kamu.',
};

export const cancelEditActionText = {
  titleText: 'Yakin ingin membatalkan?',
  contentText: 'Perubahan yang telah dibuat tidak akan disimpan. Apakah kamu yakin ingin membatalkan?',
  submitButtonText: 'Ya, Batalkan',
  cancelButtonText: 'Tutup',
};

export const formUpsertText = {
  backButtonText: 'Kembali',
  cancelButtonText: 'Batal',
  createTitleText: 'Create User',
  detailTitleText: 'User Details',
  editTitleText: 'Edit User',
  editButtonText: 'Edit',
  submitButtonText: 'Simpan',
};

export const formAccountDetailsText = {
  titleText: 'Account Details',
  nameLabelText: 'Nama',
  namePlaceholderText: 'Masukkan nama user',
  emailLabelText: 'Email',
  emailPlaceholderText: 'contoh@email.com',
  passwordLabelText: 'Password',
  passwordPlaceholderText: 'Masukkan password',
  roleLabelText: 'Role',
  rolePlaceholderText: 'Pilih role',
  brandLabelText: 'Brand',
  brandPlaceholderText: 'Pilih brand',
  platformLabelText: 'Platform',
  platformPlaceholderText: 'Pilih platform',
  nipLabelText: 'NIP',
  nipPlaceholderText: 'Masukkan NIP',
  joinDateLabelText: 'Join Date',
  joinDatePlaceholderText: 'Pilih Join Date',
  terminateDateLabelText: 'Terminate Date',
  terminateDatePlaceholderText: 'Pilih Terminate Date',
};

export const passwordValidationText = {
  invalidText: 'Password tidak memenuhi syarat!',
  minLengthText: 'Minimal 8 karakter',
  capitalLetterText: 'Gunakan minimal 1 huruf kapital (Contoh: A, B, C)',
  specialCharacterText: 'Gunakan minimal 1 karakter khusus (Contoh: * - , !)',
};
